<template src="./template.html" />
<script>
import DetailPage from 'src/modules/pages/detail-page'
import Scaffolding from './../scaffolding.vue'
import { mapGetters } from 'vuex'
import { firebase } from '@firebase/app'
import CommentBox from 'src/modules/comments_box'
const firestore = firebase.firestore()
const { DocumentReference } = firebase.firestore
export default {
  name: 'TaskDetail',
  components: {
    'DetailPage': DetailPage,
    CommentBox
  },
  mixins: [Scaffolding],
  props: {
    'id': {
      type: String,
      default: ''
    }, 
    'mode': {
      type: String,
      default: ''
    },
    'data': {
      type: Object,
      default: () => {}
    },
    'scaffolding': {
      type: Object,
      default: () => {}
    },
    backLink: {
      type: Object,
      default: () => ({ path: '/task-management' })
    },
    subTaskRoute: {
      type: String,
      default: '/task-management/task-detail'
    }
  },
  data () {
    return {
      dataPath: null,
      hideComment: false,
      privateScaffolding: this.R.path(['scaff'], this.scaffolding),
      isLoading: true,
      isSubmiting: false,
      queryPath: ['Tasks', this.id ? this.id : this.$route.query.id ? this.$route.query.id : null],
      baseData: this.mode && this.mode === 'CREATE' ? {} : this.data,
      taskMasterData: null,
      type: this.R.path(['type'], this.scaffolding),
      similarTask: null,
      masterdata: {
        task: {
          id: 'task',
          name: 'Công việc'
        }
      }
    }
  },
  computed: {
    userTaskGroup() {
      if(!this.user || this.mode === 'CREATE') return []
      let assignee = this.R.path(['assignee'], this.baseData)
      let assistant = this.R.path(['assistant'], this.baseData)
      let reporter = this.R.path(['reporter'], this.baseData)
      let createdBy = this.R.path(['metaData', 'createdBy'], this.baseData)
      return [(createdBy === this.user.email && createdBy === assignee) || 
      (createdBy === this.user.email && createdBy === assistant) ||
      assistant === this.user.email || assignee === this.user.email ? 'assignee' : '',
      (createdBy === this.user.email && createdBy === reporter) || reporter === this.user.email ? 'reporter' : '', 
      (createdBy === this.user.email && createdBy === assistant) || assistant === this.user.email ? 'assistant' : '',
      createdBy === this.user.email ? 'createdBy' : '']
    },
    ...mapGetters([
      'user',
      // 'userProfile'
    ])
  },
  created () {
    // this.getScaffolding()
    this.dataPath = this.queryPath.join('/')
  },
  updated() {
    // this.getScaffolding()
  },
  methods: {
    async querySubtask() {
      let id = this.id ? this.id : this.$route.query.id ? this.$route.query.id : null
      if(id) {
        await this.$query(['Tasks'], [['parentTask', '==', firestore.collection('Tasks').doc(id)]], null, null, null, null, null, 'namis')
          .then(res => {
            if(this.$refs.detailPage) this.$refs.detailPage._data.data.subTask = res.data
          })
      }
    },
    getScaffolding() {
      let readonly = this.computedPermission()
      this.type = this.R.path(['type', 'id'] ,this.baseData) || this.R.path(['type'] ,this.scaffolding)
      this.type = this.type ? this.type : 'task'
      this.privateScaffolding = this.parrentScaffolding[`${this.type}${readonly ? '_readonly' : ''}`]
      if(this.mode !== 'CREATE' && this.baseData.assistant === this.user.email && this.user.email !== this.baseData.assignee
      && this.user.email !== this.baseData.reporter && this.user.email !== this.baseData.metaData.createdBy) {
        this.privateScaffolding.items['item-1'].colBody[1]['item-7'].readonly = true
      }
    },
    async fetchTaskMasterData() {
      if(this.privateScaffolding) {
        // Add subtask when edit only
        this.privateScaffolding.items['item-1'].colBody[0]['item-3'].editable = this.$refs.detailPage._data.privateMode === 'EDIT'
        this.taskMasterData = await this.$query(['MasterData', 'TaskMasterData'])
        // user list

        this.computeStatus()
        this.assignPriority()
        if(this.type === 'idea') {
          this.privateScaffolding.items['item-1'].colBody[0]['item-1'].colBody[1]['item-1'].datasource.options = this.taskMasterData.listBU
          this.privateScaffolding.items['item-1'].colBody[0]['item-1'].colBody[1]['item-2'].datasource.options = this.taskMasterData.listIdeaType
        }
        let listUsers = await this.$query(['Users', 'UsersIndex'])
        this.privateScaffolding.items['item-1'].colBody[1]['item-5'].datasource.options = listUsers.list
        this.privateScaffolding.items['item-1'].colBody[1]['item-6'].datasource.options = listUsers.list
        this.privateScaffolding.items['item-1'].colBody[1]['item-7'].datasource.options = listUsers.list
        this.privateScaffolding.items['item-1'].colBody[1]['item-10'].datasource.options = listUsers.list

        this.privateScaffolding.items['item-1'].colBody[0]['item-3'].columns[3].datasource.options = listUsers.list
        this.privateScaffolding.items['item-1'].colBody[0]['item-3'].columns[4].datasource.options = listUsers.list
        this.privateScaffolding.items['item-1'].colBody[0]['item-3'].columns[5].datasource.options = listUsers.list

        this.$query(['MasterData', 'Department']).then(res => {
          let result = this._.values(this._.omit(res,'metaData'))
          this.privateScaffolding.items['item-1'].colBody[0]['item-3'].columns[2].datasource.options = result
          this.privateScaffolding.items['item-1'].colBody[1]['item-4'].datasource.options = result
        })
      }
    },
    assignPriority() {
      this.privateScaffolding.items['item-1'].colBody[1]['item-2'].datasource.options = this.R.values(this.taskMasterData.listPriority)
      this.privateScaffolding.items['item-1'].colBody[0]['item-3'].columns[4].datasource.options = this.R.values(this.taskMasterData.listPriority)
    },
    
    computeStatus() {
      let vm = this
      let listStatus = vm.R.values(vm.taskMasterData.listStatus)
      this.privateScaffolding.items['item-1'].colBody[0]['item-3'].columns[1].datasource.options = listStatus
      if(this.mode === 'CREATE') {
        listStatus = listStatus.filter(item => item.id === 'new')
        listStatus[0].next = ['new']
      } else {
        listStatus = listStatus.map(item => {
          item.next = vm.R.flatten([vm.R.values(vm.R.pick(vm.userTaskGroup, item.next)), item.id])
          return item
        })
      }
      this.privateScaffolding.items['item-1'].colBody[1]['item-1'].datasource.options = listStatus
    },
    showSimilarTask() {
      let parentTaskID = this.R.path(['parentTask', 'id'], this.baseData)
      let vm = this
      if(this.similarTask) {
          let nodes = [
            {
              label: this.similarTask.parrent.title,
              caption: this.similarTask.parrent.assignee,
              to: {
                name: vm.subTaskRoute,
                path: vm.subTaskRoute,
                query: {
                  id: parentTaskID
                },
                params: {
                  id: parentTaskID,
                  mode: 'EDIT',
                  scaffolding: this.parrentScaffolding[this.similarTask.parrent.type.id]
                }
              }
            }
          ]
          nodes = nodes.concat(this.similarTask.childs.map(item => ({ 'label': item.title, caption: item.assignee, to: {
                name: vm.subTaskRoute,
                path: vm.subTaskRoute,
                query: {
                  id: item._id
                },
                params: {
                  id: item._id,
                  mode: 'EDIT',
                  scaffolding: this.parrentScaffolding[item.type.id]
                }
              }
            })))
          this.privateScaffolding.items['item-1'].colBody[1]['item-15'].items = nodes
        }
    },
    async handlerSubmit (payload, resolve, reject) {
      let vm = this
      let submitModel = { id: payload.id, data: payload.data }
      this.mutableSubtask(submitModel.data)
      submitModel.data.type = this.masterdata[this.type]
      await vm.$command.execute('updateTaskManagement', submitModel).then(res => resolve(res)).catch(err => reject(err))
    },
    mutableSubtask(data) {
      data.parentTask = data.parentTask ? data.parentTask.path : ''
      for(let key in data.subTask) {
        if(data.subTask[key].hasOwnProperty('parentTask') && data.subTask[key].parentTask instanceof DocumentReference) {
          data.subTask[key].parentTask = data.subTask[key].parentTask.path
        }
      }
    },
    async detailPageFetched (data) {
      this.baseData = data
      this.getScaffolding()
      this.querySubtask()
      this.fetchTaskMasterData()
      this.fetchSimilarTask()
      this.isLoading = false
    },
    async fetchSimilarTask() {
      let parentTask = this.R.path(['parentTask', 'id'], this.baseData)
      if(parentTask) {
        let fetchParrent = this.$query(['Tasks', parentTask], null, null, null, null, null, 'namis')
        let fetchChild = this.$query(['Tasks'], [['parentTask', '==', firestore.collection('Tasks').doc(parentTask)]], null, null, null, null, null, 'namis')
        await Promise.all([fetchParrent, fetchChild]).then(res => {
          this.similarTask = {}
          this.similarTask.parrent = res[0]
          this.similarTask.childs = res[1].data
          this.showSimilarTask()
        }).catch(e => console.log(e))
      }
    },
    computedPermission() {
      let isReadonly = this.$store.state.user.email ? !(this.baseData && this.baseData.reporter === this.$store.state.user.email || this.R.path(['metaData', 'createdBy'], this.baseData) == this.$store.state.user.email) : true
      if(this.mode && this.mode === 'CREATE' || this.mode == '' && this.id == '') {
        isReadonly = false
      }
      return isReadonly
    },
  },
  watch: {
    async privateScaffolding(newValue) {
      if(newValue) {
        await this.fetchTaskMasterData()
      }
    }
  }
}
</script>
 